/* eslint-disable parog-web/no-glint-expect-error-directive */
import type { TOC } from '@ember/component/template-only';
import { array, fn } from '@ember/helper';
import { on } from '@ember/modifier';
import fuiDropdown from 'wise-fui-modules/modifiers/fui-dropdown';
interface Signature {
  Args: {
    updateComment?: unknown;
  };
}

const CommentSuggestions: TOC<Signature> = <template>
  <div
    {{fuiDropdown}}
    class='ui icon top left pointing dropdown basic button !mr-0 !mt-[1.6em]'
  >
    <i class='lightbulb icon outline'></i>
    <div class='menu'>
      <div class='header'>
        <i class='lightbulb icon outline'></i>
        Suggestions de commentaires
      </div>
      {{#each
        (array
          'A faire à jeun'
          "A faire réaliser en laboratoire d'analyse médicale"
          'A faire réaliser par IDE à domicile'
          'Renouvelable 1 fois'
          'Renouvelable 2 fois'
          'Renouvelable 3 fois'
          'Renouvelable 4 fois'
        )
        as |suggestion|
      }}
        <div
          role='button'
          class='item'
          {{! @glint-expect-error }}
          {{on 'click' (fn @updateComment suggestion)}}
        >
          {{suggestion}}
        </div>
      {{/each}}
    </div>
  </div>
</template>;

export default CommentSuggestions;
